import ModalImg from './ModalImg';

export default ModalImg;
